var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveFromPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5,76.9L64.5,76.9L64.5,76.9z M90.9,38.6c0-1.9-1.6-3.5-3.5-3.5H12.8c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5h74.7  C89.4,42.1,90.9,40.5,90.9,38.6z M49.5,57.3c0-1.9-1.6-3.5-3.5-3.5H12.8c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h33.2  C47.9,60.8,49.5,59.2,49.5,57.3z M90.9,19.9c0-1.9-1.6-3.5-3.5-3.5H12.8c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h74.7  C89.4,23.4,90.9,21.9,90.9,19.9z M49.5,75.9c0-1.9-1.6-3.5-3.5-3.5H12.8c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5h33.2  C47.9,79.4,49.5,77.9,49.5,75.9z M81,66.4l9-9c1.4-1.4,1.4-3.6,0-5c-1.4-1.4-3.6-1.4-5,0l-9,9l-9-9c-1.4-1.4-3.6-1.4-5,0  c-1.4,1.4-1.4,3.6,0,5l9,9l-9,9c-1.4,1.4-1.4,3.6,0,5c0.7,0.7,1.6,1,2.5,1c0.9,0,1.8-0.4,2.5-1l9-9l9,9c0.7,0.7,1.6,1,2.5,1  c0.9,0,1.8-0.4,2.5-1c1.4-1.4,1.4-3.6,0-5L81,66.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFromPlaylist);
export default __webpack_public_path__ + "static/media/remove-from-playlist.cf87e220e6011b5232c8525474395b1b.svg";
export { ForwardRef as ReactComponent };